export class SelectedLocationState {
  regions: string[] = []
  businessUnits: string[] = []
  countries: string[] = []
}